/** Stored custom-form schemas may be a JSON string or an already-parsed object. */
export function parseJsonSafe<T>(value: T | string): T {
  if (typeof value === 'string') {
    return JSON.parse(value) as T;
  }
  return value;
}
